import React from 'react';

export const ActionMenuContext = React.createContext<{
    onExecute: () => void;
}>(null as any);
